module.exports = __webpack_public_path__ + "img/arrow-right.19978bbf.svg";